export default {
  language: 'Please select language',
  terms: 'Terms · Privacy Policy',
  Disclaimers: 'Disclaimers and Risk Warnings',
  annualized: 'The average annualized rate is 56.74%, and the cumulative income is 163.15%.',
  drawdown: 'The average annualized rate is 87.43%, and the cumulative income is 145.72%',
  college:'Matrix Power College',
  web3:'Matrix Power WEB3',
  home: {
    attention: 'Attention: To ensure asset security, it is strictly prohibited to disclose sensitive information such as wallet addresses and private keys in chat scenarios',
    EmailInput: 'Please enter your email address',
    TechnicalSupport: 'Technical Support',
    emailFormat: 'Please enter a valid email format',
    contact: 'Contact Us',
    title: 'Matrix Power',
    banner_desc: 'Enable every investor to enjoy the prospects brought by top AI quantitative strategies',
    banner_highlight: 'Quant Trading + AI',
    banner_future: ' Driving the Future of Industry Trading',
    discover: 'Discover more →',
    about: 'Frequently Asked Questions',
    explore: 'Start exploring',
    schematicDiagram:'Schematic diagram of the past two years',
    dataModule: {
      funds: 'Funds are protected by',
      exchange: 'Top service provider hosting',
      description: 'Fully compliant with US regulatory requirements, customer assets are completely isolated. Implement multi-layer protection through MPC and HSM, and obtain SOC 2 Type II certification',
      scale: 'The scale of strategy service funds on Matrix Power platform has reached',
      StrategicPlan: 'Strategy Plan',
      yieldRate: 'Estimated annualized rate of return',
      strategy: 'Earn returns from your trading strategy anytime, anywhere.',
      // return: ' Get returns',
      advantage: 'Powerful quantitative strategies combined with MatrixPower\'s security and protection bring an ultimate experience.'
    },
    carousel: {
      hedge: 'Cross-Exchange Hedging',
      arbitrage: ' Arbitrage Strategy',
      MarketPremise: 'Core strategy',
      MarketPremise_1: 'Stable arbitrage is achieved through different means when the same calibration object experiences price differences on different exchanges.',
      build: 'Strategic Highlights',
      build_1: 'Fearless of market fluctuations and stable profits.',
      mean: 'Price Mean Reversion',
      mean_1: 'Relying on mean reversion logic, profits come from cross-exchange price differences',
      view: 'View More ',
      foreignExchange: 'High-Frequency Quantitative Investment',
      arbitrage_1: ' Strategy',
      collect: 'Core strategy',
      collect_1: 'Collect trading data from major global foreign exchange markets over the past decade, and use AI statistical models to accurately capture over 30 explicit factors that affect the rise and fall of foreign exchange. Through these factors, high-frequency trading can be conducted to obtain ultra-high returns.',
      factor: 'Strategic Highlights',
      factor_1: 'Engage in ultra-high frequency trading with an annual return rate exceeding 100%',
      combination: 'Factor Combination Strategy Optimization',
      combination_1: 'Automatic trading when high-accuracy factor combinations send clear signals'
    },
    card: {
      company_intro: 'View More',
      discover: 'Discover more',
      company_intro_one: 'Matrix Power Finacial Technology Limited',
      ai_quant: 'AI Quantification',
      ai_quant_one: 'AI quantification replaces traditional traders with efficient trading programs...',
      app_download: 'APP Download',
      app_download_one: 'Matrix Power is an app that helps you achieve... through AI quantitative technology',
      app_matrix_desc: 'Matrix Power APP is a service butler that helps you grow your digital assets through AI quantitative technology.',
      contact_us: 'Contact Us',
      contact_us_one: 'Matrix Power Finacial Technology Limited'
    },
    accordion: {
      title1: 'Company Introduction',
      content1: 'The MP-Suiying project provides professional AI quantitative technology strategies. Team members have senior and professional backgrounds in financial engineering, IT, and statistics. Our goal is to break the high threshold of quantitative trading in traditional financial markets, and distribute profits fairly and disclose trading data and customer asset data transparently for investors in need.',
      title2: 'Matrix Power\'s Mission',
      content2: 'Through our mature quantitative strategies and trading algorithms, we help investors conduct 7*24 uninterrupted transactions in specific markets. At the same time, in order to achieve financial inclusion, we also provide custody qualifications for small clients.',
      title3: 'Matrix Power\'s Advantages',
      content3: 'Stable high returns with no market risk. The source of high returns is the excellent algorithm of MP-AI quantitative trading and the high profitability of digital currencies. The stable annualized return can reach 60%. Since the team was founded in 2023, the weekly return data has basically no drawdown, meaning no loss data. Moreover, our assets are hosted in an independent account of a Swiss bank. In case of non-market risks, our hosted assets will be fully compensated by the trust insurance of the Swiss bank.',
      title4: 'Why choose us',
      content4: 'Colleagues can be divided into traditional fund institutions and traditional quantitative institutions. Compared to traditional financial institutions, our returns are unparalleled. Traditional financial institutions aim to expand their management scale, charge management fees, and do not care about investors returns. Compared to traditional quantitative institutions, their investment threshold is at least $3 million to $8 million, which ordinary investors cannot participate in. Specific private channels or channels are required to have the opportunity to participate in traditional quantitative trading, which yields much lower returns than our quantitative strategy.',
      title5: 'How to Profit',
      content5: 'Our profit model is that after setting parameters, our AI quantitative strategy automatically monitors the top 100 market capitalization digital currencies on Binance, Bybit, okx, and Bitget exchanges. When price differences are found, we conduct arbitrage by buying low and selling high, with a maximum of more than 30 transactions per second, fully automated by the AI quantitative system. Because it is fully hedged, transactions are not affected by price fluctuations, and profits can be made whether buying up or down.'
    },
    partner: {
      title: 'Matrix Power Partnership',
      subtitle: 'The AI quantitative strategy will operate with full transparency on a well-known exchange, making the entire trading process open and visible.',
      slogan: 'Driven by Technology, Led by Innovation'
    },
    quant: {
      title: 'Matrix Power Quant',
      subtitle: 'Empowering quantitative trading models with cutting-edge AI technology for excess returns',
      leftTitle: 'Annualized Returns of Three Strategies',
      leftDesc: 'Three quantitative strategy models — digital assets, forex and A-share options — operate independently with isolated risks, suited to diverse risk preferences',
      stat1: 'Forex Multi-Factor Trading Model',
      stat2: 'Cross-Exchange Risk-Free Arbitrage Model',
      stat3: 'A-Share ETF Options Arbitrage',
      viewDetail: 'View Details',
      feeLabel: 'Technical Service Fee',
      securityTitle: 'Security Matrix',
      sec1: 'Fund Transfer Permission',
      sec1Val: '0',
      sec2: 'Dual Risk Control',
      sec2Val: '100%',
      sec3: 'Product Run-in Period',
      sec3Val: '0 days',
      sec4: 'Ultimate Liquidity',
      sec4Val: '7x24h'
    },
    service: {
      title: 'Service Scale',
      subtitle: 'Continuously delivering steady capital growth for investors through AI quantitative strategies. All data provided by third-party platforms',
      item1: 'High-Net-Worth Clients',
      num2: '74M+',
      item2: 'USD Assets Under Management',
      num3: '3+',
      item3: 'Years Without Drawdown'
    },
    aiSection: {
      title: 'YanTai AI',
      subtitle: 'YanTai AI drives the autonomous digital economy — AI creates value, humans share the returns.',
      running: 'AI Running',
      participants: 'Active Human Participants',
      targetApr: 'Target APR',
      aiAgents: 'AI Agents',
      aiGenerated: 'AI Generated',
      engine: 'AI Promotion Engine',
      l1: 'Latest AI Models',
      l1v: 'Accuracy',
      l2: '24/7 Online Around the Clock',
      l2v: 'Always Online',
      l3: 'Complete Tasks Smartly & Efficiently',
      l3v: 'Efficiency Up',
      l4: 'Enterprise-Grade Security',
      l4v: 'Reliability',
      productsTitle: 'Two AI-Derived Products',
      productsDesc: 'YanTai AI is well developed with practical capabilities. Users can generate returns through its two AI-derived products (AiGenNext and AI Promotion Engine)'
    },
    faqSubtitle: 'Clear your doubts and get started quickly',
    fixed: {
      title: 'APP Fixed-Income Products',
      subtitle: 'Designed to lower the investment threshold for small capital — risk-free with no lock-up period, inclusive finance for everyone',
      download: 'Download Now',
      feat1: 'Min. Investment: $1000',
      feat2: 'Avg. Annualized: 15%',
      feat3: 'No Lock-up Period'
    },
    notOpen: 'Coming Soon'
  },
  about: {
    titleName: 'Matrix Power Financial Technology',
    titleName1: 'About Us',
    gs: '  Technology Limited',
    qurMission: 'Our Mission',
    company_profile: 'Matrix Power is a quantitative technology company registered in Hong Kong with independent digital copyrights in mainland China. The core R&D team comes from top international corporations and investment banks.',
    team_intro: 'Our mission is to break the barriers of traditional financial markets with top AI quantitative strategies, enabling both institutional and individual investors to enjoy stable value-added brought by AI quantitative strategies at the lowest cost.',
    slogan: 'Gather wisdom, break barriers, share the future',
    commitment: 'is our commitment to every investor!',
    work: 'In addition, all our work is',
    user: 'user-centric,',
    safety: 'user protection is our top priority. Therefore, we have embedded the most advanced security measures and strict data privacy control measures in the Matrix Power system.',
    name: 'Matrix Power Finacial Technology Limited',
    reason: 'Why choose',
    SimplifiedName: ' Matrix Power Quant',
    aiName: 'YanTai AI',
    title1: 'AI Quantitative Business',
    Department: {
      DepartmentName1: 'Technology Operations Department',
      DepartmentIntroduction1: 'Responsible for MatrixPower APP function development and operation',
      DepartmentName2: 'Blockchain Technology R&D Department',
      DepartmentIntroduction2: 'Focus on RWA blockchain technology development',
      DepartmentName3: 'Quantitative Investment Research Department',
      DepartmentIntroduction3: 'AI Quantitative Strategy Development ',
      DepartmentName4: 'International Business Department',
      DepartmentIntroduction4: 'Singapore, Vietnam, North African markets'
    },
    title2: 'Digital Assets',
    prospect: {
      prospectName1: 'Multi-Strategy AI Engine',
      prospectHome1: 'We do not rely on market fluctuations in a single direction. Through diversified quantitative models such as statistical arbitrage, market neutrality, event driven, and macro hedging, we systematically explore opportunities for mispricing in all major asset markets worldwide, strip market systemic risks, and purely obtain excess returns.',
      prospectName2: 'Cutting-Edge Technology Driven',
      prospectHome2: 'Our strategy is rooted in massive market data, relying on our own ultra-high computing power and top-notch AI algorithms. Through high-frequency data processing and pattern recognition, our system can anticipate small market imbalances earlier and more accurately than traditional methods.',
      prospectName3: 'Strict Risk Control',
      prospectHome3: 'Risk control is our first credo. We adopt real-time value monitoring, multi-dimensional stress testing, and strict stop-loss and position management mechanisms to ensure that investment portfolios remain resilient in the face of extreme market conditions and keep downside risks firmly under control.'
    }
  },
  quantify: {
    strategy: 'Our Strategy',
    arbitrage: 'Cross agency hedging',
    StrategicCore: 'As the cryptocurrency market is decentralized and fragmented, price discrepancies for the same cryptocurrency may occur between different exchanges due to factors such as liquidity, user demand, trading volume, or regional differences. The core of this strategy lies in:',
    StrategicCore_1: 'Buy a certain digital currency on the exchange with a lower price.',
    StrategicCore_2: 'Simultaneously sell the same amount of the digital currency on the exchange with a higher price.',
    StrategicCore_3: 'Profit from the price difference between these two transactions.',
    StrategicCore_4: 'This is an ultra-low-risk arbitrage strategy because it does not rely on predicting the future overall trend of the market, but rather leverages temporarily existing market inefficiencies.',
    strategyName: "High frequency quantization",
    collect: 'Data Collection',
    dataCollection: 'Extraction and Screening of Explicit Factors',
    content: "Collect trading data from major global forex markets over the past 10 years, covering different economic cycles (boom, recession, recovery) to ensure the completeness and representativeness of samples",
    screeningMethod: "Adopt the Bayesian Information Criterion (BIC) for factor screening to eliminate variables with weak correlation and insufficient explanatory power. Through dynamic linear regression fitting, quantify the influence weight of each factor on exchange rate fluctuations, and finally extract multiple core explicit factors such as ABCDEFG. After in-sample backtesting, the individual prediction accuracy of selected factors all reaches over 90%, ensuring the effectiveness and stability of the factors.",
    triggerCondition: "When the high-accuracy factor combination sends a clear signal, the probability of forex price increase is judged to be 99.95%, and an automatic trading order is sent to the exchange at this time.",
    strategyCore: "Core: Precise decision-making system based on multi-factor model",
    change: 'Learn how we bring change to others',
    experience: 'Listen to our clients share their experiences collaborating with Matrix Power and how our investment strategies have helped them achieve their financial goals',
    defaultPanels: {
      title1: "Matrix Power has completely transformed the way I manage my digital assets. Their AI quantitative strategy helped my investment portfolio grow by 45% in the past year, far exceeding my expectations.",
      name1: "Zhang Ming",
      label1: "Tech Entrepreneur",
      belonging1: 'Future Technology Co., Ltd.',
      title2: "As an investor just starting to explore digital assets, the Matrix Power team provided me with valuable guidance. Their platform is easy to use and their strategies are straightforward, allowing me to invest with peace of mind.",
      name2: "Chen Yalin",
      label2: "Digital Asset Enthusiast",
      belonging2: 'Individual Investor',
      title3: "As an experienced investor, I am deeply impressed by Matrix Power's professional standards. Their market analysis is accurate and their risk management strategies are comprehensive—they are a trustworthy partner.",
      name3: "Li Ting",
      label3: "Senior Investor",
      belonging3: 'Global Investment Group',
      title4: "I recommend Matrix Power to all my clients. Their services are highly transparent, their customer support team is responsive, and most importantly, they consistently deliver stable investment returns.",
      name4: "Wang Jianguo",
      label4: "Financial Advisor",
      belonging4: 'Wealth Management Advisory Firm'
    },
    attention: 'Contact Us',
    title: 'What is AI Quantification?',
    introduction: "AI quantification is the replacement of traditional traders' trading responsibilities with efficient trading programs. The essence of quantitative trading is to obtain through big data and specific statistical models",
    winRate: ' The highest winning rate',
    transaction: ' The transaction plan is executed automatically.',
    transactionAdvantage: 'Compared with traditional manual trading, the advantages of quantitative trading are: first, transactions are not affected by human nature and strictly abide by trading discipline; second, quantitative programs can conduct high-frequency transactions, with dozens of transactions per second, which is irreplaceable by humans; third, AI quantitative programs continuously collect market data and can adjust parameters to respond to market changes.',
    Advantage: {
      name: 'AI Quantitative Business',
      AdvantageTitle1: 'Professional and Senior International Background',
      introduction1: 'The core team of Matrix Power Financial has top backgrounds in statistics, IT, finance, and risk control, all with master\'s degrees or above. Compared with investment returns, we value risk more. Ensuring the stable appreciation of each participant\'s assets has always been our primary goal.',
      AdvantageTitle2: 'Sufficient Capital and Strict Risk Control System',
      introduction2: 'Matrix Power Financial has sufficient capital as a safety margin, which can be checked by each participant at any time. Technically, our AI quantitative risk control system continuously monitors market risk indicators 7*24 hours to ensure that our transactions are always conducted within safe quantitative indicators.',
      AdvantageTitle3: 'High Data Transparency and Well-Known Cooperative Institutions',
      introduction3: 'Matrix Power\'s partners are world-class institutional custody teams and banks, ensuring the safety and transparency of invested digital assets.',
      structureTitle: 'Strategy, Data, Code Display',
      structureHome: 'Code demonstration, position display (3 APP screenshots), AI quantitative trading framework, investment return rate comparison',
      structureF: 'Discover more →'
    },
    plan: {
      title: 'Quantitative Services',
      planName1: 'Win-Win Collective Plan',
      planName2: 'Stable Win Special Account Plan',
      PlanHighlights: 'Plan Highlights:',
      PlanHighlights1_1: 'Through integrated custody accounts, every small investor can participate in AI quantitative investment and share profits.',
      PlanHighlights1_2: 'Matrix Power promises not to distinguish between small and large funds, and distribute profits fairly. Every investor, regardless of fund size, can query background data.',
      PlanHighlights1_f: 'Discover more',
      PlanHighlights2_1: 'Customers can open their own custody accounts, which means there is no need to transfer funds to a third-party custody account.',
      PlanHighlights2_2: 'Matrix Power only has investment authority for sub-accounts, not fund transfer authority.',
      PlanHighlights2_3: 'Large capital special accounts will have reduced exchange fees, which can improve returns by reducing fees.',
      PlanHighlights2_f: 'Note: To protect the interests of existing investors, this project opens fundraising irregularly. Please contact investment consultants.'
    }
  },
  information: {
    name: 'Information Center',
    poster: 'Follow the trend and gradually become wealthy together',
    today: 'Today',
    moon: ' Month ',
    day: ' Day',
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    homePage: 'Home',
    PreviousPage: 'Previous Page',
    NextPage: 'Next Page',
    more: 'Learn more'
  },
  contact: {

    HongKong: 'Hong Kong',
    HongKong_1: 'Room 509, 5th Floor, Cloud End Building, 111 Tung Choi Street, Tai Po District, Kowloon, Hong Kong (Headquarters)',
    Wuhan: 'Wuhan',
    Wuhan_1: "Room 715, 7th Floor, Ping An Financial Center, Zhongshan Avenue, Jiang'an District, Wuhan City, Hubei Province (Office)",
    Changsha: 'Changsha',
    Changsha_1: '18th Floor, Building 18, Hongshuwan, Changsha County, Changsha City, Hunan Province (Office)',
    office: 'Contact Us',
    name: 'Contact Us',
    title: 'Customer service provides full assistance to make communication more hassle-free',
    office_one: 'Our address',
    service: 'We are committed to providing the highest quality financial services to global clients for the management of your wealth appreciation. Welcome to inquire about the details of our products and services, and feel free to contact us.',
    formDesc: 'Our support team assists you throughout the process to make communication effortless. Tell us the issue you are facing and how we can help — we are glad to serve you. We usually reply within a few minutes.',
    sendEmail: 'Send Email',
    companyAddress: 'Company Address',
    yourEmail: 'Your Email',
    yourName: 'Your Name',
    yourQuestion: 'Your Question',
    questionPlaceholder: 'Enter the question you would like us to answer...',
    emailPlaceholder: 'Enter your email',
    namePlaceholder: 'Enter your name',
    submit: 'Submit',
    submitSuccess: 'Thanks for your message! We will get back to you soon.'
  },
  agreement:{
    Disclaimers: 'Disclaimer',
    rights: '2025 Matrix Power Fintech Co., Ltd. All Rights Reserved',
    p1: 'This report is prepared by Matrix Power Fintech Co., Ltd., which is regulated by the Companies Law of the Hong Kong Special Administrative Region (HKSAR), and distributed in the Greater China region. Matrix Power Fintech Co., Ltd. is a limited liability company registered in the Hong Kong Special Administrative Region.',
    p2: 'This report is not intended for or directed at any person to whom the distribution or publication of this report is prohibited under the local laws or regulatory rules. If you have any questions, please consult a local lawyer.',
    p3: 'This report shall not be deemed as an offer or invitation to trade any securities or financial instruments in any jurisdiction.',
    p4: 'The opinions and recommendations contained on this website are not suitable for all investors, and do not take into account the special circumstances, objectives or needs of individual clients, and shall not be deemed as advice or strategies for specific clients in relation to specific securities or financial instruments.',
    p5: 'Investors shall not replace their independent judgment with this website or make decisions solely based on this report, and shall consult professional opinions when necessary. The opinions, views and forecasts contained in this report are only those of the analysts on the date of issuance of this report, and the prices, values and returns of the relevant securities or financial instruments may fluctuate.',
    p6: 'The performance data cited in this report represents past performance, and past performance is not indicative of future returns. The forecasts made in the analysis may be based on corresponding assumptions. Any change in assumptions may significantly affect the predicted returns, and such opinions, views or forecasts may be changed at any time without notice.',
    p7: 'Sales personnel, traders and other professionals of Matrix Power Fintech Co., Ltd. may express market comments and/or trading views orally or in writing that are inconsistent with the opinions and recommendations in this report based on different assumptions and standards and using different analysis methods; the quantitative investment business department of Matrix Power Fintech Co., Ltd. may independently make investment decisions that are inconsistent with the opinions or recommendations in this report; Matrix Power Fintech Co., Ltd. has no obligation to update such opinions and recommendations to all recipients of the report. Matrix Power Fintech Co., Ltd. may issue reports that are inconsistent with the opinions, views and forecasts contained in this report at different times.',
    p8: 'The information in this report is obtained from sources that we believe to be reliable, but Matrix Power Fintech Co., Ltd.: (1) does not guarantee the accuracy, completeness, timeliness or availability of any information; (2) shall not be liable for any direct, indirect or consequential losses arising from the use of the materials in this report.',
    p9: 'Matrix Power Fintech Co., Ltd.: (1) may hold positions in digital currencies issued by the companies mentioned in this report and conduct transactions; (2) may engage in market-making or dealing activities on specific digital asset exchanges.',
    p10: 'This report is for the use of intended recipients only. No institution or person may reproduce, copy, distribute or transmit this document (in whole or in part) to other institutions and/or persons without the prior written authorization of Matrix Power Fintech Co., Ltd. If forwarding is permitted by Matrix Power Fintech Co., Ltd., the forwarder shall obtain independent legal opinions to confirm that the forwarding complies with the requirements of applicable local laws and regulations. Matrix Power Fintech Co., Ltd. and its employees shall not be liable for any direct or indirect losses incurred by the forwarder and/or its clients due to the use of this report or the contents stated in the report.',
    name: 'Matrix Power Fintech Co., Ltd.  A limited liability company registered in the Hong Kong Special Administrative Region'
  },
  privacy:{
    privacy: 'Privacy Policy',
    name1: '1. Information We Collect',
    title1: 'When you use Matrix Power\'s quantitative services, we may collect the following information:',
    p1_1: 'Account Information: Name, contact information, and identity documents you provide during registration (for compliance verification)',
    p1_2: 'Transaction Information: Data related to quantitative services such as your investment strategy selection, asset allocation, and transaction records',
    p1_3: 'Device Information: Model of the accessing device, IP address, and browser type (for security risk control)',
    name2: '2. How We Use Your Information',
    title2: 'We only use the collected information for the following purposes:',
    p2_1: 'Providing Quantitative Strategy Services: Optimizing AI strategy models based on your investment preferences',
    p2_2: 'Compliance and Risk Control: Complying with financial regulatory requirements and preventing transaction risks',
    p2_3: 'Service Optimization: Analyzing user behavior to improve product experience (after anonymization)',
    name3: '3. Information Sharing and Disclosure',
    title3: 'We will not sell your personal information to third parties, and will only share it in the following cases:',
    p3_1: 'When we obtain your explicit authorization',
    p3_2: 'When complying with laws and regulations or responding to legitimate requests from judicial authorities',
    p3_3: 'Sharing with partners that provide necessary technical support (a non-disclosure agreement must be signed)',
    name4: '4. Information Protection Measures',
    title4: 'We adopt security measures that meet financial industry standards to protect your information:',
    p4_1: 'Encrypted storage and transmission of data',
    p4_2: 'Hierarchical control of access permissions',
    p4_3: 'Regular security audits and vulnerability fixes',
    name5: '5. Your Rights',
    title5: 'You have the right to:',
    p5_1: 'Access and correct your personal information',
    p5_2: 'Delete your account information if the conditions are met',
    p5_3: 'Contact us to consult about privacy-related issues (support@matrixpower.com)',
    name6: '6. Changes to the Agreement',
    title6: 'We may update this policy in accordance with business or regulatory requirements. After the change, it will be announced in a prominent position on the official website. Your continued use of the service will be deemed as acceptance of the change.',
    retain: '2025 Matrix Power. All Rights Reserved'
  },
  appDownload: {
    download: 'APP Download',
    butler: 'Your one click capital growth platform',
    title: 'Empower investors with top-notch AI quantitative strategies and enjoy daily steady returns with zero risk!',
    trust: 'Trusted by users worldwide',
    relyOn: 'All service assets are insured by UBS to eliminate non market risks and enjoy profits',
    establish: 'Founded in',
    user: 'Served Users',
    country: 'Scope of Services',
    restriction:'(Excluding restricted areas)',
    globalUsers:'global users',
    confirm: 'Please confirm',
    prompt: 'About to download the MatrixPower App installation package (APK format). Please ensure your device allows installation of apps from unknown sources',
    Cancel: 'Cancel',
    download1: 'Confirm Download',
    list: {
      header_1: 'Module Partitioning for Easier Use',
      p1_1: 'Invest conveniently anytime, anywhere',
      p1_2: 'Data-driven decision-making, multi-dimensional display of price fluctuations of various digital currencies',
      header_2: 'Technology-Driven, Quantitative Strategy Package Matrix',
      p2_1: 'Clearly label the profit range of each package, obtain daily profits, withdraw as needed, and share profits!',
      p2_2: 'Multiple investment packages are available for more flexible investment.',
      header_3: 'Intelligent Information Collection, Breaking Barriers',
      p3_1: 'By using NLP technology to capture key information from the global digital asset market, customers can stay up-to-date with the latest market trends in real time.',
      p3_2: 'Support user interaction and build a positive investment ecosystem.',
      footList1: {
        Header1: 'Homepage',
        title1: 'Event Preview',
        Header2: 'Functions',
        title2: 'Stable income',
        Header3: 'News',
        title3: 'Latest Hot Topics',
      },
      footList2: {
        Header1: 'foundation',
        title1: 'AI quantification technology',
        Header2: 'highlight',
        title2: 'Stable income',
        Header3: 'safety',
        title3: 'Guaranteed principal and interest',
      },
      footList3: {
        Header1: 'Cross-Platform',
        title1: 'Real-Time Capture',
        Header2: 'Quantitative',
        title2: 'Multiple Pushes',
        Header3: 'Interaction',
        title3: 'Like & Comment',
      },
    }
  },

  footer: {
    address: "Room 715, 7F, Ping An Financial Center, Zhongshan Avenue, Jiang'an District, Wuhan, Hubei, China",
    nav: {
      contact: "Contact Us",
      compliance: "Compliance",
      navigation: "Navigation",
      legal: "Legal",
      academy: "Matrix Power College",
      about: "Matrix Power",
      home: "Home",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      risk: "Risk Disclosure",
      followUs: "Follow Us"
    },
    copyright: "©2026 MatrixPower",
    disclaimer: {
      p2: "Services are subject to regional restrictions. Users in certain countries/regions may not be able to access all features.",
      p1: "Cryptocurrency investment involves risk. Past performance does not guarantee future results. MatrixPower assumes no liability for any investment losses."
    }
  },
  quantPage: {
    essence: {
      title1: 'The Essence of ',
      titleHl: 'Quantitative Trading',
      desc: 'An investment approach that uses mathematical models, statistical analysis and computer programs to find patterns in massive data and execute trades automatically. Data-driven decision making eliminates emotional interference for rational investing',
      trend: 'Trend Prediction',
      factor: 'Factor Analysis',
      auto: 'Automated Trading'
    },
    strategy: {
      tag: 'Core Strategies',
      title: 'Quantitative Investment Strategies',
      subtitle: 'Leveraging AI model computing advantages to fully mine explicit factors and continuously improve trading win rates.',
      card1Title: 'Three Independent Strategies',
      card1Desc: 'Digital asset, forex and options strategy lines operate independently with independent risk control for steady wins.',
      card2Title: 'Professional Team Management',
      card2Desc: 'Each strategy line has dedicated research and risk-control teams with real-time monitoring and dynamic tuning',
      card3Title: 'Positive Monthly Returns',
      card3Desc: 'All strategies delivered positive monthly returns with stable performance'
    },
    matrix: {
      title: 'Product Matrix',
      tab1: 'Forex Multi-Factor Trading',
      tab2: 'Cross-Exchange Risk-Free Arbitrage',
      tab3: 'A-Share ETF Options Ultra-High Alpha'
    },
    chart: {
      title: 'Avg. Return Rate',
      subtitle: 'Based on 10 years of trading data backtesting',
      annual: 'Annualized Return',
      monthly: 'Monthly Return',
      annualVal1: '71%',
      annualVal2: '24%',
      annualVal3: '104%',
      monthlyVal1: '5.19%',
      monthlyVal2: '2%',
      monthlyVal3: '8.67%',
      minInvest: 'Minimum Investment',
      minInvestVal1: '$25K',
      minInvestVal2: '$2M',
      minInvestVal3: '$1M',
      lossProb: 'Loss Probability',
      lossProbSub: 'Max loss rate: 10%'
    },
    p1: {
      title: 'Forex Multi-Factor Trading Model',
      subtitle: 'Multi-factor AI modeling for intelligent high-frequency forex trading',
      f1: 'Collected 10 years of complete trading data from global major forex markets',
      f2: 'AI large models capture 30+ explicit up/down factors for combined modeling',
      f3: 'Automated high-frequency trading, opening and closing positions by explicit factors',
      f4: 'Strict 10% stop-loss line with rigorous risk control'
    },
    p2: {
      title: 'Cross-Exchange Risk-Free Arbitrage Model',
      subtitle: 'Capturing cross-exchange spreads on the same asset, hedged for stable arbitrage',
      f1: 'Yantai guarantees coverage — losses above 1% are compensated by Yantai',
      f2: 'Return rates estimated from historical data',
      f3: 'Hedged arbitrage model locking in spread profits'
    },
    p3: {
      title: 'A-Share ETF Options Ultra-High Alpha',
      subtitle: 'Leveraging options pricing deviations and cross-market spreads to build hedged portfolios',
      f1: 'Predicts daily K-line turning points to determine monthly direction',
      f2: 'Finds mispricing through options pricing models',
      f3: 'Harvests ultra-high Alpha returns'
    },
    coop: {
      tag: 'Partnership',
      title: 'Why Choose Matrix Power Quant?',
      c1Title: 'Fund Security',
      c1i1t: 'Physical Fund Isolation',
      c1i1d: 'Clients open their own accounts; Yantai only obtains API trading permission with zero fund-transfer rights, ensuring absolute principal safety.',
      c1i2t: 'Dual Risk Control',
      c1i2d: 'In-house risk models monitor abnormal fluctuations in real time, reducing systemic market risk and strategy drawdown to industry lows.',
      c1i3t: 'Ultimate Liquidity',
      c1i3d: 'No lock-up periods across all products — investors can withdraw anytime based on their needs, keeping assets highly liquid.',
      more1: 'See More',
      c2Title: '24/7 Guided Support',
      c2i1t: 'Account Opening',
      c2i1d: 'Complete account-opening guidance to finish registration quickly.',
      c2i2t: 'API Binding',
      c2i2d: 'Assistance with API binding to ensure smooth trading.',
      c2i3t: 'Deposits & Withdrawals',
      c2i3d: 'Free fund in/out with simple, fast operations — control your account anytime.',
      more2: 'See More',
      c3Title: 'Transparent Profit Sharing',
      c3i1t: 'Transparent Profit-Sharing Process',
      c3i1d: 'Profits are tallied on the 1st-3rd of each month with statements sent to clients. After verification, clients pay a 50% technical service fee. Yantai has no fund-transfer rights over client assets.'
    },
    philo: {
      tag: 'Investment Philosophy',
      title: 'Long-Term Win-Win · Steady and Far',
      subtitle: 'Trust is the cornerstone of the financial world; transparency is our promise to investors',
      card1Title: 'Capital Capacity Control',
      card1Desc: 'AI strategies are highly sensitive to capital capacity. Yantai strictly controls scale through invitation-only access to protect existing client returns',
      card2Title: 'Institutional Positioning',
      card2Desc: 'Committed to professional quantitative investment positioning, pursuing only reasonable capital growth with strict risk control and compliance',
      card3Title: 'Long-Term Win-Win Ecosystem',
      card3Desc: 'Building long-term win-win ecosystems with like-minded partners, pursuing steady long-term capital growth'
    },
    trust: {
      titlePre: 'Trust',
      titlePost: " is Yantai's most valuable asset",
      title2: 'Steadiness Leads Far',
      btn: 'Join Now'
    }
  },
  yantai: {
    heroHl: 'YanTai AI',
    heroTitle: ' Unlocks Infinite Possibilities for the Future',
    heroDesc: 'As one of the earliest companies deeply training AI models, Yantai has mature AI applications including quantitative trading assistance, the AI Promotion Engine, and the AIgennext project incubator',
    heroBtn1: 'AI Promotion Engine',
    heroBtn2: 'AiGenNext',
    headerTitle: 'AI Promotion Engine',
    headerDesc: 'Through AI models, 300-500 real devices are operated in a human-like manner — searching, posting, adding and replying autonomously for 7×24 traffic promotion',
    box1Title: 'Unified Device Control',
    box1Desc: 'Manage all devices in one place and publish content efficiently',
    box1Item1: 'Manage massive devices in batches from a single backend, no repeated logins',
    box1Item2: 'Skip tedious copy-paste and reformatting, focus on creativity and strategy',
    box1Item3: 'Compatible with images, texts, videos, links and emojis, adapting to all major platforms',
    box1Item4: 'Aligned with platform algorithms and user preferences, one-click differentiated distribution',
    panel1Name: 'Unified Multi-Device Management',
    panel1Subtitle: 'Manage massive devices in batches once enabled, boosting efficiency',
    panel1Add: 'Add Device',
    panel1StatTotal: 'Total Devices',
    panel1StatOnline: 'Online Devices',
    panel1StatOffline: 'Offline Devices',
    panel1StatStandby: 'Standby Devices',
    panel1Search: 'Enter device name/ID',
    panel1TagAll: 'All',
    panel1TagOnline: 'Online',
    panel1TagOffline: 'Offline',
    panel1TagIdle: 'Idle',
    panel1Batch: 'Batch Actions',
    panel1BadgeMaster: 'Master',
    panel1BadgeActive: 'Active',
    panel1BadgeStandby: 'Standby',
    panel1BadgeOffline: 'Offline',
    panel1DevId: 'ID: D-1024 Last active: 12:38',
    panel1StOnline: 'Online',
    panel1StIdle: 'Idle',
    panel1StOffline: 'Offline',
    box2Title: 'AI Smart Interaction',
    box2Desc: 'Auto-collecting industry knowledge, AI-empowered smart social operations',
    box2Item1: 'Keyword recognition, sentiment analysis and auto replies',
    box2Item2: 'Precise user engagement with emotion-graph analysis',
    box2Item3: 'Automatically capture potential users',
    box2Item4: 'Make brand social media operations more professional and efficient',
    panel2Name: 'AI Smart Interaction',
    panel2Subtitle: 'Auto replies & automatic potential-user capture',
    auto: 'Auto',
    p2c1Name: 'AI Comment Auto-Reply',
    p2c1Desc: 'Thanks for your support! More details on our homepage 👇',
    p2c2Name: 'AI DM Auto-Reply',
    p2c2Desc: '"Hello, how can I help you?"',
    p2c3Name: 'AI Auto-Rewrite',
    p2c3Desc: 'Differentiated versions generated for TikTok/Ins',
    p2c4Name: 'AI Mention Monitor',
    p2c4Desc: '5 positive mentions replied automatically',
    p2c5Name: 'Keyword Recognition',
    p2c5Desc: 'Capture industry trends in real time with sentiment analysis',
    p2c6Name: 'Potential User Capture',
    p2c6Desc: 'Identify prospective users automatically to boost conversion',
    p2c7Name: 'Smart Operations Assistant',
    p2c7Desc: 'Professional and efficient brand social media operations',
    p2s1: "Today's Interactions",
    p2s1Unit: ' times',
    p2s1Trend: '+12% vs. yesterday',
    p2s2: 'Operating Cost Saved',
    p2s2Unit: ' hrs',
    p2s2Trend: '87% routine inquiries automated',
    p2s3: 'Auto Replies Sent',
    p2s3Unit: ' msgs',
    p2s3Trend: '12 DMs · 35 comments',
    p2s4: 'Potential Users Captured',
    p2s4Unit: ' people',
    p2s4Trend: 'New prospects today',
    box3Title: 'One-Click AI Content Creation',
    box3Desc: 'State your need in one sentence, AI generates and processes content end-to-end',
    box3Item1: 'One-sentence input, AI auto-generates images and videos',
    box3Item2: 'Auto-adapts to all platform sizes with one-click multi-language translation',
    box3Item3: 'Content auto-archived, delivered straight to the publishing editor',
    box3Item4: 'Scheduled publishing supported, reducing team operation costs',
    panel3Name: 'AI Content Creation',
    panel3Subtitle: 'Videos, images, articles',
    styleTitle: 'Style Models',
    more: 'More',
    styleRealistic: 'Realistic',
    styleIllustration: 'Illustration',
    style3D: '3D',
    styleCinematic: 'Cinematic',
    styleWatercolor: 'Watercolor',
    styleCyber: 'Cyber',
    p3Ph1: 'Upload a reference image or type text, ',
    p3Ph2: 'describe the image you want to generate',
    p3Generate: 'Generate',
    p3Save: 'Save Design',
    box4Title: '24/7 Always Online',
    box4Desc: 'Round-the-clock guarding, protecting your brand operations securely',
    box4Item1: 'Online 24/7, executing all kinds of tasks smartly and efficiently',
    box4Item2: 'Enterprise-grade security protection',
    box4Item3: 'Fully automatic around the clock, zero omission of key information',
    box4Item4: 'Instant user response, continuously safeguarding brand image',
    agHead1: 'Web3',
    agHead2: ' to ',
    agHead3: 'AI Evolution',
    agDesc: 'Aigennext is an incubation project based on YanTai AI, with the core philosophy: "AI creates value, humanity shares the returns"',
    agBtn: 'Start Exploring'
  },
  aboutPage: {
    heroPre: 'Quantitative Trading + ',
    heroHl: 'AI Intelligence',
    heroSub: 'Hybrid Company',
    heroTagline: '" Gathering Wisdom · Steady Growth · Shared Future "',
    coDesc: 'A fintech institution headquartered in Hong Kong with offices in Wuhan and Changsha. Our core team comes from top international tech companies and investment banks',
    statFounded: 'Founded',
    statScale: 'USD Service Scale',
    statAlgo: 'Proprietary Algorithms',
    tag1: 'Licensed & Compliant',
    tag2: 'In-house Algorithms',
    tag3: 'Global Vision',
    advTitle: 'Advantages of Matrix Power',
    advSubtitle: 'Matrix Power possesses cutting-edge AI agent development technology, a highly professional team and extensive quantitative research experience — making your choice more secure',
    tab1: 'AI Agents',
    tab2: 'Lean Core Team',
    tab3: 'Strict Risk Control',
    a1l1h: 'Self-developed',
    a1l1r: ' AI large models',
    a1l2r: 'High-frequency trading for ',
    a1l2h: 'excess returns',
    a1l3r: 'Precisely capturing over ',
    a1l3m: ' ',
    a1l3b: 'explicit factors',
    a2l1h: '15+',
    a2l1r: ' elite team members',
    a2l2h: '90%',
    a2l2r: '+ with Master/PhD degrees',
    a2l3r: 'Extensive quantitative research ',
    a2l3h: 'experience',
    a2l4: 'Deep technical expertise',
    a3l1h: 'Real-time ',
    a3l1r: 'value monitoring',
    a3l2h: 'Multi-dimensional ',
    a3l2r: 'stress testing',
    a3l3h: 'Strict ',
    a3l3r: 'stop-loss & position',
    a3l4: ' management mechanism',
    visionTitle: 'Our Vision',
    visionDesc1: 'Redefine quant with intelligence, empower intelligence with quant — becoming a ',
    visionDesc2: 'world-leading AI-driven asset management institution'
  },
  appd: {
    servedUsers: '12,000+ Users Served',
    usersLabel: 'Global Users (excluding restricted regions)',
    trustDesc: 'MatrixPower APP is trusted by users worldwide, offering asset custody and smart allocation, eliminating non-market risks for worry-free returns',
    statRegion: 'Trading Regions',
    statDownloads: 'Downloads',
    statRating: 'User Rating',
    statPositive: 'Positive Reviews',
    f1t: 'Modular Layout',
    f1d: 'Investment plans and community news in real time, intelligent data analysis, round-the-clock trade monitoring for optimal strategies',
    f2t: 'Technology-Driven',
    f2d: 'Cutting-edge AI quant algorithms with over 99% recognition rate, automated execution and a complete risk-control system for safer investing',
    f3t: 'Transparent Trading',
    f3d: 'Real-time fund monitoring keeps flows safe and transparent; blockchain-encrypted storage secures user assets',
    f4t: 'Technical Support',
    f4d: 'Professional 7x24 service with rapid-response mechanisms, keeping trading smooth and resolving user issues promptly',
    secSubtitle: 'Institution-grade security with transparent, compliant oversight. Multi-layer protection via KYC and AML, certified with SOC 2 Type II',
    assetTitle: 'Client Asset Protection',
    assetL1: 'Segregated asset storage',
    assetL2: 'Cold storage of assets in-app',
    assetL3: 'Isolated digital asset security',
    tagPrincipal: 'Principal Absolutely Safe',
    tagSelfOpen: 'Self-operated Accounts',
    dualL1: 'Professional risk team monitors in real time with smart alerts',
    dualL2: 'SOC 2 Type II certified',
    tagRiskModel: 'In-house Risk Model',
    transTitle: 'Trading Transparency',
    transL1: 'Full-chain transaction data available',
    transL2: 'Smart tamper-proof encryption',
    transL3: 'Real-time reconciliation refreshed by the second, viewable multiple times a day',
    tagRealtime: 'Real-time Checkable',
    tagLiquid: 'High Liquidity',
    ctaDesc: 'Service assets are insured on-chain, eliminating non-market risks for worry-free returns'
  },
}